@if (tracked_item.placeholder != null && tracked_item.placeholder == true) {
  <div class="message-bubble tracked-item created">
    <div
      class="message-bubble-wrapper"
      [ngClass]="{ 'is-drawer': isDrawer }"
      style="border: 1px solid #dbe0ea"
    >
      <div class="flex flex-row mb-3 justify-content-between">
        <p-skeleton styleClass="mb-4" width="5rem" borderRadius="16px" />
        <div class="flex flex-row">
          <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
          <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
          <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
        </div>
      </div>

      <p-skeleton styleClass="mb-2" borderRadius="16px" />
      <p-skeleton width="15rem" styleClass="mb-2" borderRadius="16px" />
      <p-skeleton width="20rem" styleClass="mb-2" borderRadius="16px" />

      <p-skeleton width="10rem" height="1.5rem" borderRadius="16px" />

      <div class="flex justify-content-between mt-3">
        <p-skeleton width="8rem" height="2rem" />
        <p-skeleton width="8rem" height="2rem" />
      </div>
    </div>
  </div>
} @else {
  <div
    class="message-bubble tracked-item created"
    [ngClass]="{
      waiting: tracked_item.answer_status == 'answered',
      closed: tracked_item.answer_status == 'closed',
      draft: tracked_item.answer_status == 'draft',
    }"
    (mouseenter)="hovering = true"
    (mouseleave)="hovering = false"
    (click)="openDrawer($event, tracked_item, company)"
  >
    <div
      class="message-bubble-wrapper"
      [ngClass]="{ 'is-drawer': isDrawer }"
      style="border: 1px solid #dbe0ea"
    >
      @if (loading) {
        <div class="upload-loading">
          <div>
            <img src="assets/img/ajax-loader.gif" alt="Loading" />
          </div>
        </div>
      }
      @if (isDrawer) {
        <div
          class="status d-flex align-items-center justify-content-between pe-2"
          style="position: relative"
        >
          <div class="d-flex align-items-center">
            @if (tracked_item.answered) {
              <!-- Closed by -->
              @if (tracked_item.satisfied) {
                <ds-status-badge
                  tooltip="Closed by {{
                    tracked_item.satisfied_user?.full_name
                  }} at {{
                    tracked_item.last_satisfied_changed
                      | amCalendar: moment_calendar_format
                  }}"
                  color="green"
                  text="CLOSED"
                  [user]="tracked_item.satisfied_user"
                />

                @if (tracked_item.last_answered) {
                  <div
                    class="avatar avatar-second"
                    tooltip="Answered by {{
                      tracked_item.answer_user?.full_name
                    }} at {{
                      tracked_item.last_answered
                        | amCalendar: moment_calendar_format
                    }}"
                  >
                    @if (tracked_item.answer_user?.pictureUrl) {
                      <img src="{{ tracked_item.answer_user?.pictureUrl }}" />
                    }
                    @if (!tracked_item.answer_user?.pictureUrl) {
                      <div class="initials">
                        {{
                          tracked_item.answer_user?.full_name[0] +
                            tracked_item.answer_user?.full_name
                              .split(" ")
                              .splice(-1)
                              .toString()[0]
                        }}
                      </div>
                    }
                  </div>
                }
              }

              <!-- Answered by -->
              @if (tracked_item.answered && !tracked_item.satisfied) {
                <ds-status-badge
                  tooltip="Answered by {{
                    tracked_item.answer_user?.full_name
                  }} at {{
                    tracked_item.last_answered
                      | amCalendar: moment_calendar_format
                  }}"
                  color="orange"
                  text="ANSWERED"
                  [user]="tracked_item.answer_user"
                />
              }

              <!-- Created By -->
              <div
                class="avatar avatar-second"
                tooltip="Created by {{
                  tracked_item.created_by?.full_name
                }} at {{
                  tracked_item.date | amCalendar: moment_calendar_format
                }}"
              >
                @if (tracked_item.created_by?.pictureUrl) {
                  <img src="{{ tracked_item.created_by?.pictureUrl }}" />
                }
                @if (!tracked_item.created_by?.pictureUrl) {
                  <div class="initials">
                    {{
                      tracked_item.created_by?.full_name[0] +
                        tracked_item.created_by?.full_name
                          .split(" ")
                          .splice(-1)
                          .toString()[0]
                    }}
                  </div>
                }
              </div>
            } @else {
              <ds-status-badge
                tooltip="Created by {{
                  tracked_item.created_by?.full_name
                }} at {{
                  tracked_item.date | amCalendar: moment_calendar_format
                }}"
                color="red"
                text="OPEN"
                [user]="tracked_item.created_by"
              />
            }
          </div>
          <ds-pin
            hovering="true"
            [type]="pinModel"
            [pin]="tracked_item?.pinned_item"
            [identifier]="tracked_item?.id"
            [model]="tracked_item"
            [company]="{ id: tracked_item?.company }"
          />
        </div>
      }

      <div class="client-task-trigger">
        <!-- Status and Comments -->
        <div class="status-comments">
          @if (
            !isDrawer &&
            tracked_item.answer_status == "draft" &&
            !tracked_item.satisfied &&
            !isTemplateManager
          ) {
            <div class="status" style="position: relative">
              <ds-status-badge tooltip="Draft" color="grey" text="DRAFT" />
            </div>
          } @else if (
            !isDrawer && !tracked_item.answered && !isTemplateManager
          ) {
            <div class="status d-flex align-items-center" style="position: relative; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;">
              <ds-status-badge
                pTooltip="Created by {{
                  tracked_item.created_by?.full_name
                }} at {{
                  tracked_item.date | amCalendar: moment_calendar_format
                }}"
                color="red"
                text="OPEN"
                [user]="tracked_item.created_by"
                tooltipPosition="top"
              />
              @if (autoRemind) {
                <div [pTooltip]="'Due date (' + (tracked_item.initial_reminder_date | amDateFormat: 'MMM, Do YYYY') + ')'" tooltipPosition="top" class="ml-2 d-flex align-items-center" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;">
                  <i class="tio-calendar"></i>
                  <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;">
                    {{
                      tracked_item.initial_reminder_date
                        | amDateFormat: "MMM, Do YYYY"
                    }}
                  </div>
                </div>
              }
            </div>
          } @else if (
            tracked_item.answered &&
            !tracked_item.satisfied &&
            !isTemplateManager &&
            !isDrawer
          ) {
            <div class="status" style="position: relative">
              <ds-status-badge
                tooltip="Answered by {{
                  tracked_item.answer_user?.full_name
                }} at {{
                  tracked_item.last_answered
                    | amCalendar: moment_calendar_format
                }}"
                color="orange"
                text="ANSWERED"
                [user]="tracked_item.answer_user"
              />
            </div>
          }
          @if (tracked_item.satisfied && !isTemplateManager && !isDrawer) {
            <div class="status" style="position: relative">
              <ds-status-badge
                tooltip="Closed by {{
                  tracked_item.satisfied_user?.full_name
                }} at {{
                  tracked_item.last_satisfied_changed
                    | amCalendar: moment_calendar_format
                }}"
                color="green"
                text="CLOSED"
                [user]="tracked_item.satisfied_user"
              />
            </div>
          }
          <div class="client-task-card-footer-right">
            @if (
              !isPreview &&
              !isDrawer &&
              tracked_item &&
              tracked_item?.integration_data != null
            ) {
              @if (tracked_item.integration_data.has_qbo_error) {
                <div
                  style="
                    font-size: 22px;
                    line-height: 1;
                    color: #ff3b2d;
                    cursor: pointer;
                  "
                  (click)="goToQuickBooks(tracked_item)"
                >
                  <i
                    class="feather alert-circle"
                    tooltip="Error in QuickBooks: {{
                      tracked_item.integration_data.error
                    }}."
                  ></i>
                </div>
              }
            }
            @if (
              !isPreview &&
              !isDrawer &&
              tracked_item &&
              tracked_item?.clients_to_notify?.length > 0
            ) {
              @for (client of tracked_item.clients_to_notify; track client) {
                <div class="comments-link">
                  <div
                    class="client-task-pill"
                    tooltip="{{ client?.username }} notified at {{
                      tracked_item.date | amCalendar: moment_calendar_format
                    }}"
                  >
                    <div class="avatar avatar-22">
                      <img src="{{ client?.pictureUrl }}" />
                    </div>
                  </div>
                </div>
              }
            }
            @if (
              !isDrawer &&
              tracked_item &&
              tracked_item.attachments_qty > 0
            ) {
              <ds-icon-counter
                tooltip="Attachments"
                icon="tio-attachment"
                [number]="tracked_item.attachments_qty"
              />
            }
            @if (
              !isPreview &&
              !isDrawer &&
              getCommentCount() > 0) {
              <ds-icon-counter
                tooltip="Comments"
                icon="tio-comment_vs_outlined"
                [number]="getCommentCount()"
              />
            }
            @if (
              !isPreview &&
              !isPreview &&
              tracked_item.from_job &&
              data?.user_type == 1) {
              <div
                class="comments-link"
                (click)="openRelatedJobPanel(tracked_item.from_job, $event)"
                [ngStyle]="!isDrawer && tracked_item"
              >
                <ds-icon-counter
                  pTooltip="Open Job"
                  tooltipPosition="top"
                  icon="tio-briefcase_outlined"
                  color="blue"
                />
              </div>
            }
            @if (
              !isPreview &&
              !isDrawer &&
              data?.user_type == 1) {
              <ds-pin
                [hovering]="hovering"
                [type]="pinModel"
                [pin]="tracked_item?.pinned_item"
                [identifier]="tracked_item?.id"
                [model]="tracked_item"
                [company]="{ id: tracked_item?.company }"
                skip-drawer
              />
            }
          </div>
        </div>
        <!-- End of Status and Comments -->
        @if (tracked_item.upload_loading) {
          <div class="upload-loading">
            <div>
              <img src="assets/img/ajax-loader.gif" alt="Loading" />
              <br />Uploading file...
            </div>
          </div>
        }
        <div class="message-bubble-text client-task-title">
          <div class="ql-editor p-0">
            @if (!canEditTrackedItemMessage) {
              <div
                class="tracked-item-message"
                [innerHTML]="tracked_item.message | keepHtml"
              ></div>
            } @else {
              <div
                #inputTrackedItemMessage
                id="inputTrackedItemMessage"
                name="inputTrackedItemMessage"
                contenteditable="true"
                [innerHTML]="tracked_item.message"
              ></div>
              <button
                class="btn btn-success btn-block"
                style="color: white !important"
                (click)="updateTrackedItemMessage(inputTrackedItemMessage)"
              >
                Update
              </button>
              <!-- <button class="btn btn-default btn-block"
        (click)="canEditTrackedItemMessage = !canEditTrackedItemMessage">Cancel</button> -->
            }
          </div>

          <!-- <div *ngIf="tracked_item.type == 6">
      Please categorize and/or comment to describe this expense:
    </div> -->
        </div>

        @if (
          (isDrawer && data?.user_type == 1 && !canEditTrackedItemMessage) ||
          (isTemplateManager && data?.user_type == 1)
        ) {
          <div class="edit-tracked-item">
            <!-- <button
      class="btn btn-link"
      (click)="editTrackedItemMessage(inputTrackedItemMessage)"
      >
      <i class="feather edit"></i>
    </button> -->
          </div>
        }
        @if (isDrawer) {
          <div class="attachments-content">
            <div class="file-items">
              @for (file of tracked_item.attachments; track file) {
                <div
                  class="file-item"
                  filePreview
                  [type]="file.ext"
                  [etag]="file.etag"
                  [file]="file"
                >
                  <i
                    class="file-icon file-{{ file.ext }}"
                    style="background: url('{{ file.url }}')"
                  ></i>
                  <div class="file-name">{{ file.filename }}</div>
                </div>
              }
            </div>
          </div>
        }
        @if (isDrawer && tracked_item.last_update) {
          <div class="created-by-drawer">
            Edited by {{ tracked_item.last_editor?.full_name }} at
            {{ tracked_item.last_update | amCalendar: moment_calendar_format }}
          </div>
        }
        @if (tracked_item.type == 6) {
          <div>
            <div class="qb-card-wrapper">
              <div class="qb-card-first-line">
                <div
                  class="qb-card-tag qb-card-account"
                  tooltip="{{ tracked_item.integration_data.payment_account }}"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17 8V5C17 4.73478 16.8946 4.48043 16.7071 4.29289C16.5196 4.10536 16.2652 4 16 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6M4 6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8H18C18.2652 8 18.5196 8.10536 18.7071 8.29289C18.8946 8.48043 19 8.73478 19 9V12M4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H18C18.2652 20 18.5196 19.8946 18.7071 19.7071C18.8946 19.5196 19 19.2652 19 19V16"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20 12V16H16C15.4696 16 14.9609 15.7893 14.5858 15.4142C14.2107 15.0391 14 14.5304 14 14C14 13.4696 14.2107 12.9609 14.5858 12.5858C14.9609 12.2107 15.4696 12 16 12H20Z"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {{ tracked_item.integration_data.payment_account }}
                </div>
                <div class="arrow">
                  <svg
                    width="9"
                    height="16"
                    viewBox="0 0 9 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L8.70711 7.29289C9.09763 7.68342 9.09763 8.31658 8.70711 8.70711L1.70711 15.7071C1.31658 16.0976 0.683417 16.0976 0.292893 15.7071C-0.0976311 15.3166 -0.0976311 14.6834 0.292893 14.2929L6.58579 8L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                      fill="#151C29"
                    />
                  </svg>
                </div>
                <div class="qb-card-tag qb-card-amount">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.8472 1V23"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8472 5H10.3472C9.41891 5 8.52867 5.36875 7.87229 6.02513C7.21592 6.6815 6.84717 7.57174 6.84717 8.5C6.84717 9.42826 7.21592 10.3185 7.87229 10.9749C8.52867 11.6313 9.41891 12 10.3472 12H15.3472C16.2754 12 17.1657 12.3687 17.822 13.0251C18.4784 13.6815 18.8472 14.5717 18.8472 15.5C18.8472 16.4283 18.4784 17.3185 17.822 17.9749C17.1657 18.6313 16.2754 19 15.3472 19H6.84717"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  @if (
                    tracked_item.integration_data.amount
                      .toString()
                      .includes(".")
                  ) {
                    <span>{{ tracked_item.integration_data.amount }}</span>
                  }
                  @if (
                    !tracked_item.integration_data.amount
                      .toString()
                      .includes(".")
                  ) {
                    <span>{{ tracked_item.integration_data.amount }}.00</span>
                  }
                </div>
              </div>
              <div class="qb-card-second-line">
                <div
                  class="qb-card-tag qb-card-payee"
                  tooltip="{{ tracked_item.integration_data.payee }}"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>{{ tracked_item.integration_data.payee }}</span>
                </div>
                <div class="qb-card-tag qb-card-date">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.9082 4H5.9082C4.80363 4 3.9082 4.89543 3.9082 6V20C3.9082 21.1046 4.80363 22 5.9082 22H19.9082C21.0128 22 21.9082 21.1046 21.9082 20V6C21.9082 4.89543 21.0128 4 19.9082 4Z"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.9082 2V6"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.9082 2V6"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3.9082 10H21.9082"
                      stroke="#151C29"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {{
                    tracked_item.integration_data.payment_date
                      | amDateFormat: "ll"
                  }}
                </div>
              </div>
              <div class="qb-card-description">
                {{ tracked_item.integration_data.description }}
              </div>
              <div class="qb-card-ref-open">
                @if (tracked_item?.integration_data?.ref_no) {
                  <div class="qb-card-ref">
                    Ref no. {{ tracked_item?.integration_data?.ref_no }}
                  </div>
                }
                @if (isDrawer && isAccountant) {
                  <div>
                    <a
                      class="qb-card-open"
                      target="_blank"
                      rel="noreferrer noopener"
                      style="line-height: 25px"
                      href="https://app.qbo.intuit.com/app/expense?txnId={{
                        tracked_item?.integration_data?.purchase_id
                      }}"
                    >
                      Open transaction in QB </a
                    ><span tooltip="You must be logged in to this QB company"
                      ><i
                        class="feather info"
                        style="font-size: 1.15rem; color: #485364"
                      ></i
                    ></span>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- Auto reminder text -->
        @if (isDrawer && isAccountant && canAutopilot()) {
          <label
            class="auto-remind-toggle"
            style="
              margin-bottom: 0;
              display: block;
              white-space: nowrap;
              margin-left: -5px;
              margin-bottom: 16px;
            "
          >
            <div
              class="switch-toggle"
              style="display: inline; vertical-align: 1px; float: left"
            >
              <div class="toggle-wrapper">
                <div class="toggle">
                  <input
                    type="checkbox"
                    name="urgent"
                    (change)="saveAutoRemindSettings()"
                    class="check urgent"
                    [(ngModel)]="autoRemind"
                  />
                  <b class="b switch"></b>
                  <b class="b track"></b>
                </div>
              </div>
            </div>
            <div class="auto-reminder-wrap">
              <div style="flex-grow: 1; font-size: 14px">
                Auto-Remind Client
              </div>
            </div>
          </label>
        }
        @if (isDrawer && isAccountant && canAutopilot()) {
          <div class="auto-reminder">
            <div class="flex-grow">
              <div class="wrapper">
                @if (autoRemind) {
                  <div style="clear: both">
                    <form>
                      <label
                        style="
                          display: flex;
                          cursor: pointer;
                          font-weight: normal;
                          margin-top: 15px;
                          margin-bottom: 0;
                        "
                      >
                        <div class="checkbox-wrapper">
                          <!-- <input type="checkbox" [(ngModel)]="autoRemind"> -->
                        </div>
                        <p
                          class="text-wrapper"
                          style="
                            flex-grow: 1;
                            margin-top: -3px;
                            margin-bottom: 0;
                          "
                        >
                          <span>After </span>
                          <select
                            id="autoRemindDaysSelect"
                            name="autoRemindDaysSelect"
                            [(ngModel)]="autoRemindDays"
                            (change)="saveAutoRemindSettings()"
                          >
                            <option value="1">1</option>
                            <option value="2" selected>2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                          </select>
                          <span> days auto-remind client daily.</span>
                        </p>
                      </label>
                    </form>
                  </div>
                }
                @if (autoRemind) {
                  <div
                    style="
                      margin-bottom: 16px;
                      font-size: 1rem;
                      color: #151c29;
                      margin-top: 8px;
                      font-weight: 600;
                    "
                  >
                    Start on
                    {{
                      tracked_item.initial_reminder_date
                        | amDateFormat: "MMM, Do YYYY"
                    }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      @if (data?.user_type == 1) {
        <div
          [hidden]="!isDrawer"
          class="more-options"
          dropdown
          [autoClose]="true"
        >
          <span
            class="tracked-item-more-options"
            id="{{ tracked_item.id }}"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            dropdownToggle
          >
            <i class="feather more-horizontal"></i>
          </span>
          <ul
            class="dropdown-menu dropdown-menu-end"
            *dropdownMenu
            [attr.aria-labelledby]="tracked_item.id"
          >
            <li class="dropdown-header" style="padding: 3px 14px">ACTIONS</li>
            @if (!isTemplateManager && tracked_item.satisfied != true) {
              <li (click)="closeTrackedItem(tracked_item)">
                <a>Close</a>
              </li>
            }
            @if (
              (isDrawer &&
                data?.user_type == 1 &&
                !canEditTrackedItemMessage &&
                tracked_item.answered == false) ||
              (isTemplateManager && data?.user_type == 1)
            ) {
              <li (click)="launchAdvancedEdit()">
                <a>Edit</a>
              </li>
            }
            @if (!isTemplateManager && !tracked_item.answered) {
              <li (click)="openDeleteTrackedItemModal()">
                <a>Delete</a>
              </li>
            }
            @if (!isTemplateManager && !tracked_item.answered) {
              <li (click)="pinTrackedItem()">
                <a>Pin Client Task</a>
              </li>
            }
          </ul>
        </div>
      }

      <div class="message-bubble-separator"></div>

      @if (isDrawer && tracked_item.clients_to_notify.length > 0) {
        <div
          style="
            padding-top: 15px;
            margin-bottom: -5px;
            color: #151c29;
            font-weight: 600;
          "
        >
          Clients notified
          @for (client of tracked_item.clients_to_notify; track client.id) {
            <div class="clients-to-notify">
              <div class="user">
                <div
                  tooltip="Notified at {{
                    tracked_item.date | amCalendar: moment_calendar_format
                  }}"
                  class="avatar avatar-22"
                >
                  <img src="{{ client?.pictureUrl }}" />
                </div>
                <span style="font-weight: 400">{{ client.username }}</span>
              </div>
            </div>
          }
        </div>
      }
      @if (tracked_item?.clients_to_notify?.length > 0) {
        <div
          class="message-bubble-separator"
          [ngStyle]="
            !workspaceCard &&
            tracked_item.clients_to_notify.length > 0 && {
              'margin-top': '20px',
            }
          "
        ></div>
      }
      @if (isDrawer) {
        <div
          style="
            padding-top: 15px;
            margin-bottom: -5px;
            color: #151c29;
            font-weight: 600;
          "
        >
          Client Response
          @if (
            (tracked_item.answered && !tracked_item.satisfied && isDrawer) ||
            (isDrawer && tracked_item.satisfied == true)
          ) {
            <div
              style="
                font-weight: 400;
                color: #485364;
                font-size: 13px;
                margin-top: 5px;
              "
            >
              Answered by {{ tracked_item.answer_user?.full_name }} at
              {{
                tracked_item.last_answered | amCalendar: moment_calendar_format
              }}
            </div>
          }
        </div>
      }
      @if (canAnswer && !tracked_item.is_draft) {
        <div class="tracked-item-action">
          @if (tracked_item.type == 1) {
            <div class="tracked-item-options">
              <label
                [ngClass]="{
                  selected: tracked_item.answer == 1,
                  'not-selected':
                    tracked_item.answer != 1 &&
                    tracked_item.answer != null &&
                    tracked_item.answered,
                }"
                skip-drawer
              >
                <input
                  type="radio"
                  [disabled]="tracked_item.answer != 1 && tracked_item.answered"
                  [(ngModel)]="tracked_item.answer"
                  [checked]="tracked_item.answer == 1"
                  [value]="1"
                  [name]="'question' + tracked_item.id"
                  skip-drawer
                />
                Yes</label
              >
              <label
                [ngClass]="{
                  selected: tracked_item.answer == 0,
                  'not-selected':
                    tracked_item.answer != 0 &&
                    tracked_item.answer != null &&
                    tracked_item.answered,
                }"
                skip-drawer
              >
                <input
                  type="radio"
                  [disabled]="tracked_item.answer != 0 && tracked_item.answered"
                  [(ngModel)]="tracked_item.answer"
                  [checked]="tracked_item.answer == 0"
                  [value]="0"
                  [name]="'question' + tracked_item.id"
                  skip-drawer
                />
                No</label
              >
              <label
                [ngClass]="{
                  selected: tracked_item.answer == 2,
                  'not-selected':
                    tracked_item.answer != 2 &&
                    tracked_item.answer != null &&
                    tracked_item.answered,
                }"
                skip-drawer
              >
                <input
                  type="radio"
                  [disabled]="tracked_item.answer != 2 && tracked_item.answered"
                  [(ngModel)]="tracked_item.answer"
                  [checked]="tracked_item.answer == 2"
                  [value]="2"
                  [name]="'question' + tracked_item.id"
                  skip-drawer
                />
                Not Sure</label
              >
            </div>
          }
          @if (tracked_item.type == 2) {
            <div class="tracked-item-options">
              @if (
                tracked_item.files == null ||
                tracked_item.answer_status == "open"
              ) {
                <label class="file" skip-drawer>
                  <div
                    (click)="openModalFileUpload()"
                    class="upload-files-card"
                    [ngClass]="{ 'new-tracked-item': isDrawer }"
                  >
                    <i class="feather upload" style="font-size: 16px"></i>
                    <span>
                      Select files
                      @if (
                        !isDrawer &&
                        tracked_item.files !== null &&
                        tracked_item.files.length > 0 &&
                        tracked_item.pendingUploadQty != null
                      ) {
                        <span>
                          ({{ tracked_item.pendingUploadQty }} files added)
                        </span>
                      }
                    </span>
                  </div>
                </label>
              }
              <!-- If its multiple files -->
              <!-- Show this link in the card -->
              @if (
                !isDrawer &&
                tracked_item.files != null &&
                tracked_item.files_qty > 0
              ) {
                <a [ngPlural]="tracked_item.files_qty">
                  <i class="feather external-link"></i>
                  <ng-template ngPluralCase="=1">1 uploaded file</ng-template>
                  <ng-template ngPluralCase="other"
                    >See all {{ tracked_item.files_qty }} uploaded
                    files</ng-template
                  >
                </a>
              }
              <!-- Show these in the drawer -->
              @if (isDrawer) {
                <div class="attachments-content">
                  <div class="file-items">
                    @for (
                      file of tracked_item.files;
                      track file;
                      let i = $index
                    ) {
                      <div
                        class="file-item"
                        filePreview
                        [type]="file.ext"
                        [etag]="file.etag"
                        [file]="file"
                      >
                        <i
                          class="file-icon file-{{ file.ext }}"
                          style="background: url('{{ file.url }}')"
                        ></i>
                        <div class="file-name">{{ file.filename }}</div>
                        <!-- <a class="color-red-hover" tooltip="Delete file" (click)="removeFile(i)">
                            <i class="feather trash-2"></i>
                          </a> -->
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (tracked_item.type == 3) {
            <div class="tracked-item-options new-open-text" skip-drawer>
              <!-- <textarea
                *ngIf="!tracked_item.answered"
                class="form-control chat-input"
                rows="1"
                autosize
                [(ngModel)]="tracked_item.answer_text"
                [name]="'question' + tracked_item.id"
                placeholder="Answer here"
              ></textarea> -->
              @if (!tracked_item.answered) {
                <!-- <ejs-richtexteditor
          id="testing"
          [(value)]="tracked_item.answer_text"
          [saveInterval]="10"
          [insertImageSettings]="jobsService.insertImageSettings"
          (imageUploading)="jobsService.addHeaders($event)"
          (imageUploadSuccess)="jobsService.onUploadSuccess($event)"
          [toolbarSettings]="jobsService.clientTaskToolbarSettings"
        >
        </ejs-richtexteditor> -->
                <p-editor #pEditor [(ngModel)]="tracked_item.answer_text">
                  <p-header>
                    <span class="ql-formats">
                      <select class="ql-font ql-picker">
                        <option selected>Sans Serif</option>
                        <option value="serif">Serif</option>
                        <option value="monospace">Monospace</option>
                      </select>
                    </span>
                    <span class="ql-formats">
                      <button class="ql-bold" aria-label="Bold"></button>
                      <button class="ql-italic" aria-label="Italic"></button>
                      <button
                        class="ql-underline"
                        aria-label="Underline"
                      ></button>
                      <button class="ql-strike" aria-label="Strike"></button>
                    </span>
                    <span class="ql-formats">
                      <select
                        title="Text Color"
                        class="ql-color"
                        defaultValue="rgb(0, 0, 0)"
                      ></select>
                      <span class="ql-format-separator"></span>
                      <select
                        title="Background Color"
                        class="ql-background"
                        defaultValue="rgb(255, 255, 255)"
                      ></select>
                    </span>
                    <span class="ql-formats">
                      <button
                        class="ql-list"
                        value="ordered"
                        type="button"
                      ></button>
                      <button
                        class="ql-list"
                        value="bullet"
                        type="button"
                      ></button>
                    </span>
                    <span class="ql-formats">
                      <button aria-label="Link" class="ql-link"></button>
                      <button aria-label="Image" class="ql-image"></button>
                    </span>
                  </p-header>
                </p-editor>
              }
              @if (tracked_item.answered) {
                <div
                  [innerHTML]="tracked_item.answer_text"
                  [attr.name]="'question' + tracked_item.id"
                ></div>
              }
            </div>
          }
          @if (tracked_item.type == 4) {
            <div class="tracked-item-options">
              <label
                [ngClass]="{
                  selected: tracked_item.answer == '3',
                  'not-selected':
                    tracked_item.answer != '3' && tracked_item.answer != null,
                }"
                skip-drawer
              >
                <input
                  type="radio"
                  [(ngModel)]="tracked_item.answer"
                  [checked]="tracked_item.answer == '3'"
                  [value]="'3'"
                  [name]="'question' + tracked_item.id"
                />
                Accept</label
              >
              <label
                [ngClass]="{
                  selected: tracked_item.answer == '4',
                  'not-selected':
                    tracked_item.answer != '4' && tracked_item.answer != null,
                }"
                skip-drawer
              >
                <input
                  type="radio"
                  [(ngModel)]="tracked_item.answer"
                  [checked]="tracked_item.answer == '4'"
                  [value]="'4'"
                  [name]="'question' + tracked_item.id"
                />
                Decline</label
              >
            </div>
          }
          @if (tracked_item.type == 5) {
            <div class="tracked-item-options">
              <label skip-drawer>
                <input type="checkbox" [(ngModel)]="tracked_item.answer_done" />
                Mark as done</label
              >
            </div>
          }
          @if (tracked_item.type == 6) {
            @if (tracked_item.satisfied == true) {
              @if (tracked_item?.integration_data?.deposit_id != null) {
                {{ tracked_item?.integration_data?.deposit_comment }}
              } @else {
                Account: {{ tracked_item.selectedAcc }}
              }
            } @else {
              <input
                [(ngModel)]="tracked_item.selectedAcc"
                [typeahead]="accounts"
                (typeaheadOnSelect)="selectAccount($event, tracked_item)"
                [typeaheadOptionsLimit]="9999"
                [typeaheadMinLength]="0"
                [typeaheadItemTemplate]="customItemTemplate"
                typeaheadOptionField="name"
                placeholder="Choose Account"
                [disabled]="tracked_item.satisfied == true"
                class="form-control chevron"
                style="margin-bottom: 10px"
              />
            }
          }
          <ng-template #customItemTemplate let-model="item" let-index="index">
            <div class="qb-accounts-item">
              <div class="name" title="{{ model.path }}">{{ model.path }}</div>
              <div class="category">{{ model.accountType }}</div>
            </div>
          </ng-template>
          @if (tracked_item.type == 6 && hasSelectableClass) {
            @if (tracked_item.satisfied == true) {
              @if (
                tracked_item.integration_data.selectedClass &&
                tracked_item?.integration_data?.deposit_id == null
              ) {
                Class:
                {{ tracked_item.integration_data.selectedClass }}
              }
            } @else {
              <input
                [(ngModel)]="tracked_item.integration_data.selectedClass"
                [typeahead]="classes"
                [typeaheadOptionsLimit]="9999"
                [typeaheadMinLength]="0"
                [typeaheadItemTemplate]="classSelectorTemplate"
                typeaheadOptionField="name"
                (typeaheadOnSelect)="selectClass($event, tracked_item)"
                placeholder="Choose Class"
                [disabled]="tracked_item.satisfied == true"
                class="form-control chevron"
                style="margin-bottom: 10px"
              />
            }
          }
          <ng-template
            #classSelectorTemplate
            let-model="item"
            let-index="index"
          >
            <div class="qb-accounts-item">
              <div class="name" title="{{ model.name }}">{{ model.name }}</div>
            </div>
          </ng-template>
          @if (showProgressBar) {
            <app-progress-bar
              [percentage]="progressPercentage"
              style="margin-top: 8px"
            ></app-progress-bar>
          }
          @if (
            tracked_item.answered == false &&
            !showProgressBar &&
            !shouldDisable(tracked_item)
          ) {
            <button
              class="tracked-item-button"
              [disabled]="shouldDisable(tracked_item)"
              (click)="submitAnswer(tracked_item)"
              skip-drawer
            >
              Submit
            </button>
          }

          <!-- Reopen or close buttons -->
          @if (tracked_item !== null && data?.user_type == 1 && canAnswer) {
            <div>
              @if (tracked_item.answered && !tracked_item.satisfied) {
                <div class="satisfied-with-answer">
                  @if (!isDrawer) {
                    <div class="answer-text">
                      Answered by {{ tracked_item.answer_user?.full_name }} at
                      {{
                        tracked_item.last_answered
                          | amCalendar: moment_calendar_format
                      }}
                    </div>
                  }
                  <!-- <span>Are you satisfied with this answer?</span> -->
                  <div class="satisfied-buttons" skip-drawer>
                    <button
                      class="btn btn-default justify-content-center"
                      (click)="answerTrackedItem(tracked_item, false)"
                    >
                      Re-open
                    </button>
                    <button
                      class="btn btn-success justify-content-center"
                      (click)="answerTrackedItem(tracked_item, true)"
                    >
                      Close
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          <!-- End of Reopen or close buttons -->
        </div>
      }
    </div>
  </div>
}
